/**
 * @file: description
 * @author: dongjing
 * @Date: 2020-01-16 17:40:09
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-03-06 12:22:02
 */
/**
 * @description 全局Model articleModel 挂载到 redux 上
 */
import createModel, { Tction } from '@tkit/model';
import { TkitUtils as Utils } from '@tkit/types';
import { APIS, ClassifyInfo, ParamsBodyarticleSaveNewUsingPut } from '@src/services';
import {
  ParamsuserCollectionArticleIdUsingPost,
  ParamsuserCollectionArticleIdCancelUsingPost
} from '@src/services/api/UserApi';
import * as models from '@services/model/models';
import StateBlock from 'markdown-it/lib/rules_block/state_block';
import { message } from 'antd';

export interface State {
  articleModel: {
    /** 文章分类列表 */
    classifyAll: ClassifyInfo[];
  };
}

export const articleModelState: State = {
  articleModel: {
    /** 文章分类列表 */
    classifyAll: []
  }
};

const model = createModel({
  state: articleModelState,
  namespace: 'articleModel',
  reducers: {
    /** 文章分类列表 */
    setClassifyAll: (state, action: Tction<{ classifyAll: ClassifyInfo[] }>): typeof state => {
      return {
        ...state,
        articleModel: {
          ...state.articleModel,
          classifyAll: action.payload.classifyAll
        }
      };
    }
  },
  effects: {
    // 用户增加稍后阅读文章
    *collection(
      { namespace, put, tPut, tCall },
      action: Tction<{
        params: ParamsuserCollectionArticleIdUsingPost;
        callBack: (res: models.CommonResult) => void;
      }>
    ): Iterator<{}, any, any> {
      const res = yield tCall(APIS.UserApi.userCollectionArticleIdUsingPost, action.payload.params);
      action.payload.callBack(res);
    },
    // 取消收藏稍后阅读文章
    *collectionCancel(
      { namespace, put, tPut, tCall },
      action: Tction<{
        params: ParamsuserCollectionArticleIdCancelUsingPost;
        callBack: (res: models.CommonResult) => void;
      }>
    ): Iterator<{}, any, any> {
      const res = yield tCall(
        APIS.UserApi.userCollectionArticleIdCancelUsingPost,
        action.payload.params
      );
      action.payload.callBack(res);
    },
    /**
     * @description 获取文章分类列表
     */
    *getClassifyAll(
      { tPut, tCall },
      action: Tction<{
        callBack?: () => void;
      }>
    ): Iterator<{}, any, any> {
      const res: Utils.GetROA<typeof APIS.ClassifyApi.classifyBaseAllUsingGet> = yield tCall(
        APIS.ClassifyApi.classifyBaseAllUsingGet
      );
      if (res.code === 0) {
        const { callBack } = action.payload;
        yield tPut(model.actions.setClassifyAll, { classifyAll: res.result || [] });
        callBack && callBack();
      }
    }
  }
});

export default model;
